window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

import axios from 'axios';

import 'bootstrap';
import 'bootstrap-maxlength';
import 'bootstrap-show-password';

import Dropzone from 'dropzone';
import ClipboardJS from 'clipboard';
// import OverlayScrollbars from 'overlayscrollbars';

// import * as Swal from 'sweetalert2';
// import select2 from 'select2';
import Chart from 'chart.js';

import 'datatables.net';
import 'datatables.net-bs4';

import tinymce from 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver/theme';

import * as toastr from 'toastr';
toastr.options = {
    "progressBar": true,
    "preventDuplicates": true,
    "positionClass": "toast-bottom-right",
}

import { ajaxError } from './helpers';

Dropzone.autoDiscover = false;

// window.Swal         = Swal;
window.axios        = axios;
window.toastr       = toastr;
window.Dropzone     = Dropzone;
window.ClipboardJS  = ClipboardJS;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

axios.interceptors.response.use(
    (res) => res, 
    (err) => {
        ajaxError(err);
        if(err.config.hasOwnProperty('errorHandler') && err.config.errorHandler) {
            return Promise.reject(err);
        }
    }
)